module.exports = __webpack_public_path__ + "static/bridge-holo-c2bdff041da766e94371236214f837f9.jpg";